// Runs on every page (see the application layout).

global.onload = {
  init: function() {
    // live table search — see general/table_filter.js for why this is not
    // DataTables any more
    tableFilter.init();
    // init tooltips
    tooltips.init();
    // prevent multiple form submissions
    $('form').preventDoubleSubmission();
    // Confirm popups. The defaults used to paint Prekliči solid red and Potrdi green,
    // i.e. the harmless answer wore the app's one destructive colour while the answer
    // that erased a match looked ordinary. Cancel is quiet, commit carries the weight,
    // and a dialog that destroys something asks for btn--danger per link.
    //
    // No btn-sm: these are 31px buttons on the last click before an irreversible action.
    dataConfirmModal.setDefaults({
      title: 'Potrditev',
      commit: 'Potrdi',
      commitClass: 'btn btn-primary px-4',
      cancel: 'Prekliči',
      cancelClass: 'btn btn-outline-secondary px-4'
    });

    // init custom select pickers
    $('.select-picker').selectpicker();
    $('.select-picker').on('shown.bs.select', function() {
      var $input = $(this).parent().find('.bs-searchbox input');
      setTimeout(function() { $input.focus(); }, 100);
    });
    $('.bootstrap-select .bootstrap-select').remove();  // on back button we get duplicates (removes such)
    $('.select-picker').selectpicker('refresh');        // rerenders options (on back button are not render by default because of duplicate)
  }
};
